import { render, staticRenderFns } from "./duoTrainingTileView.vue?vue&type=template&id=49cfd2be&"
import script from "./duoTrainingTileView.vue?vue&type=script&lang=js&"
export * from "./duoTrainingTileView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports